export default __webpack_public_path__ + "static/media/OrangeCounty.0511ae70.jpg";